<template>
  <v-card flat>
    <v-card-item>
      <template v-slot:prepend>
        <v-avatar color="secondary" size="small">
          <v-icon icon="mdi-shape"></v-icon>
        </v-avatar>
      </template>
      <v-card-title class="text-subtitle-1 text-primary">
        {{ $t("strings.kpi-type-title") }}
      </v-card-title>
      <v-card-subtitle class="text-caption">
        {{ $t("strings.kpi-type-hint") }}
        <v-tooltip activator="parent" location="top">
          {{ $t("strings.kpi-type-hint") }}
        </v-tooltip>
      </v-card-subtitle>
    </v-card-item>
    <v-card-text class="pt-2 pb-1">
      <v-btn-toggle :model-value="modelValue" @update:modelValue="requestChangeFromChild" mandatory variant="outlined"
        density="compact" color="primary" base-color="primary" rounded="xl" :disabled="disabled">
        <v-btn value="QUANTITATIVE" aria-label="quantitative" :title="$t('strings.kpitype-quantitative-tooltip')">
          <v-icon start="">mdi-numeric</v-icon>
          {{ $t("labels.kpitype-quantitative") }}
        </v-btn>
        <v-btn value="QUALITATIVE" aria-label="qualitative" :title="$t('strings.kpitype-qualitative-tooltip')">
          <v-icon start>mdi-alphabetical-variant</v-icon>
          {{ $t("labels.kpitype-qualitative") }}
        </v-btn>
      </v-btn-toggle>
    </v-card-text>
  </v-card>
</template>

<script setup>
import { useI18n } from "vue-i18n";

const { modelValue } = defineProps({
  modelValue: { type: String, default: "QUANTITATIVE" },
  disabled: { type: Boolean, default: false }
});
const emit = defineEmits(["request-change"]);

useI18n();

function requestChangeFromChild(type) {
  // user attempted to change the toggle; notify parent to confirm
  emit("request-change", type);
}
</script>

<style scoped>
.v-btn-toggle .v-btn {
  min-width: 120px;
}
</style>
